(function(){
  document.addEventListener('DOMContentLoaded', function() {
    function fixImageUrl(url) {
      if (!url) return url;
      
      // Swap CDN domain
      let fixed = url.replace(
        'https://cdn.shopify.com/s/files/1/0662/7868/6878/files/',
        'https://www.redstar.co.il/cdn/shop/files/'
      );
      
      // Remove Shopify size suffix (_large, _medium, _grande, etc.)
      fixed = fixed.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.\w+)/, '$2');
      
      // Append width param
      fixed += (fixed.includes('?') ? '&' : '?') + 'width=990';
      
      return fixed;
    }

    function formatMoney(price) {
      return `<span class="price">₪${Number(price).toFixed(2)}</span>`;
    }
    
    /*
    * search open button header is-expanded
    */
    let backupSearchItems = document.querySelector('.SearchMini-feedContent .SearchMini-feedProduct--container').innerHTML; //backup of html if search empty we will put this one
    let backupSearchCats = document.querySelector('.SearchMini-feedContent .SearchMini-vlog').innerHTML; //backup of html if search empty we will put this one
    
    let formSearch = document.querySelector('[data-drawer-names="search"]'); //search popup
    let offcanvasBgDimmer = document.querySelector('.Offcanvas-bgDimmer'); // search popup backgorund
    let searchBtnHeader = document.querySelector('.header_search_toggler');
    searchBtnHeader.addEventListener('click', function(e) {
      e.preventDefault();
      offcanvasBgDimmer.classList.add('has-open-offcanvas');
      formSearch.classList.add('is-expanded');
    });

    let searchBtnHeaderClose = document.querySelector('#js-search-close');
    searchBtnHeaderClose.addEventListener('click', function(e) {
      e.preventDefault();
      offcanvasBgDimmer.classList.remove('has-open-offcanvas');
      formSearch.classList.remove('is-expanded');
      let mobileClose = document.querySelector('.snize-close-button-arrow');
      if ( mobileClose ) {
        simulateTap(mobileClose);
      }
    });

    offcanvasBgDimmer.addEventListener('click', function(e) {
      e.preventDefault();
      offcanvasBgDimmer.classList.remove('has-open-offcanvas');
      formSearch.classList.remove('is-expanded');
      let mobileClose = document.querySelector('.snize-close-button-arrow');
      if ( mobileClose ) {
        simulateTap(mobileClose);
      }
    });

    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      let items = document.querySelector('.snize-ac-results-content');
      let productWrapper = document.querySelector('.SearchMini-feedProduct--container'); //container for product feed
      let productWrapperCats = document.querySelector('.SearchMini-vlog'); //container for product categories
      let resultsCounter = document.querySelector('.results_digit'); //counter of results
      let afterCounterPhrase = document.querySelector('.results_after_digit'); //after counter סה״כ 
      let resultsPhrase = document.querySelector('.search_phrase'); //search phrase
      let searchInput = document.querySelector('.SearchMini-input');//input for typing
      let counterResults = 0;
      let counterResults2 = 0;
      
      productWrapper.innerHTML = ''; //do empty after last search
      productWrapperCats.innerHTML = ''; //do empty after last search
      console.log(data);
      
      if ( items && data.items && data.items.length > 0) {
        items.setAttribute('data-products', JSON.stringify(data));

        data.items.forEach(elem => {
          console.log(elem)
          const imageUrl = fixImageUrl(elem.image_link);
          let productItem = 
          `<div class="SearchMini-feedProduct">
            <a class="SearchMini-feedItem u-animate-underline gtm-search-result-product" href="${elem.link}">
              <div class="SearchMini-feedItem-ImagePlaceHolder o-placeholder" style="background-image: url(${imageUrl});"></div>
              <div class="SearchMini-content">
                  <div class="SearchMini-feedItemName"><span>${elem.title}</span></div>
                  ${formatMoney(elem.price)}
              </div>
            </a>
          </div>`;
          productWrapper.insertAdjacentHTML('beforeend', productItem);
        });
      } else {
        productWrapper.insertAdjacentHTML('beforeend', backupSearchItems);
      }

      if ( data.categories && data.categories.length > 0 ) {
        data.categories.forEach(elem => {
          let productItemCats = 
          `<div class="SearchMini-articleSlot">
              <a class="SearchMini-articleTitle u-animate-underline gtm-search-result-article" href="${elem.link}"><span>${elem.title}</span></a>
           </div>`;
          productWrapperCats.insertAdjacentHTML('beforeend', productItemCats);
        });
      } else {
        productWrapperCats.insertAdjacentHTML('beforeend', backupSearchCats);
      }

      if ( data.categories && data.categories.length > 0 ) {
        counterResults += data.categories.length;
      }

      if (data.items && data.items.length ) {
        counterResults += data.items.length;

        counterResults2 += data.totalItems;
      }

      // resultsCounter.innerHTML = counterResults;
      resultsCounter.innerHTML = counterResults2;
      resultsPhrase.innerHTML = `"${searchInput.value}" -`;
      afterCounterPhrase.innerHTML = `סה״כ`;
    });

    function simulateTap(element) {
        const mouseDownEvent = new MouseEvent('mousedown', {
            bubbles: true,
            cancelable: true,
            clientX: 0,
            clientY: 0
        });
        element.dispatchEvent(mouseDownEvent);

        const mouseUpEvent = new MouseEvent('mouseup', {
            bubbles: true,
            cancelable: true,
            clientX: 0,
            clientY: 0
        });
        element.dispatchEvent(mouseUpEvent);

        const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            clientX: 0,
            clientY: 0
        });
        element.dispatchEvent(clickEvent);
    }
    let timer;
    document.querySelector('.SearchMini-input').addEventListener('input', function(e) {
      clearTimeout(timer);
      let $this = this;
      let mobSearchField = document.querySelector("#snize-mobile-search-input");
      let targetField = document.querySelector(".SearchMini-input");
      timer = setTimeout(() => {
        if ( mobSearchField ) {
          mobSearchField.value = $this.value;
          
          targetField.blur();
          targetField.click()
           //setTimeout(() => {
            simulateTap(targetField);
           //}, 1000);
        }
        
      }, 1000);
    });

    $(document).on('scroll', function() {
      let searchPopupDisplay = $('.snize-ac-results').css('display');
      if ( searchPopupDisplay !== 'none' ) {
        $('.snize-ac-results').css('display', 'none');
      }
    });

    
    $(document).on('Searchanise.AutocompleteUpdated', function (event, input, container) {
      document.querySelector(".SearchMini-input").focus();
      let items = document.querySelectorAll('.snize-ac-results-content li.snize-product');

      if (items) {
        items.forEach((item) => {
          let items = document.querySelector('.snize-ac-results-content')
          item.classList.add('yahoooo');
          let data = items.getAttribute('data-products');
          item.classList.remove('snize-ac-even');
          item.classList.remove('snize-ac-odd');

          data = JSON.parse(data);

          let itemID = item.getAttribute('id');
          let productID = itemID.slice(17);
          let btnAdd = document.createElement('button');
          const variant = data.items.filter(v => v.product_id === productID);
          btnAdd.setAttribute('type', 'button');
          btnAdd.setAttribute('class', 'add-to-cart product-form__submit-ajax quick-add-btn js-quick-add-btn');
          btnAdd.setAttribute('data-id', variant[0].add_to_cart_id);
          btnAdd.innerHTML = '<svg class="plus-icon" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64"><path stroke="#fff" class="cls-1" d="M32 9v46m23-23H9"></path></svg><span class="btn"></span>';
          item.appendChild(btnAdd);

          //yotpo rating
          // let yotpoStars = document.createElement('div');
          // yotpoStars.setAttribute('class', 'yotpo bottomLine yotpo-small');
          // yotpoStars.setAttribute('data-product-id', productID);
          // let titleItem = item.querySelector('.snize-title');
          // console.log(titleItem);
          // titleItem.after(yotpoStars);

          new theme.QuickAdd(document.querySelector('.snize-ac-results-content'));
        });

        // var api = new Yotpo.API(yotpo);
        // api.refreshWidgets();
        // console.log(data);
      }
    });

    $('.reset__button').on('click', function() {
      $('.site-header__search-input.snize-input-style').val('');
    })

    document.querySelector('.SearchMini-input').addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        $('.site-header__search-form').submit()
      }
    })
    
    $('#search-close').on('click', function () {
      $('.site-header__search-input.snize-input-style').val('');
    });
  }, false);
})();
